import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { builder, SANITY_REF_PATTERN } from "gatsby-plugin-sanity-image"

const Metadata = ({
  title = "Marathon Oil",
  description = "Marathon Oil",
  image,
  canonicalUrl,
}) => (
  <>
    <Helmet
      htmlAttributes={{
        lang: "en-US",
      }}
    >
      <title>{title}</title>
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, shrink-to-fit=no"
      />
      <meta property="og:description" content={description} />
      <meta name="description" content={description} />
      <meta property="og:site_name" content="Marathon Oil" />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
    </Helmet>

    {image && <MetaImage {...image} />}
  </>
)

const MetaImage = image => {
  let { url, width, height } = image

  if (SANITY_REF_PATTERN.test(image.asset._id)) {
    url = builder.image(image).width(1200).height(630).fit("crop").url()
    width = 1200
    height = 630
  }

  return (
    <Helmet>
      <meta property="og:image" content={url} />
      <meta property="og:image:width" content={width} />
      <meta property="og:image:height" content={height} />
    </Helmet>
  )
}

MetaImage.propTypes = {
  asset: PropTypes.oneOfType([
    PropTypes.shape({ _id: PropTypes.string.isRequired }),
  ]).isRequired,
  hotspot: PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number,
    x: PropTypes.number,
    y: PropTypes.number,
  }),
  crop: PropTypes.shape({
    bottom: PropTypes.number,
    left: PropTypes.number,
    right: PropTypes.number,
    top: PropTypes.number,
  }),
}

Metadata.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  canonicalUrl: PropTypes.string,
  image: PropTypes.oneOfType([
    PropTypes.shape(MetaImage.propTypes),
    PropTypes.shape({
      url: PropTypes.string.isRequired,
      width: PropTypes.number.isRequired,
      height: PropTypes.number.isRequired,
    }),
  ]),
}

export default Metadata
